import React from 'react';
import cx from 'classnames';
import { ButtonProps } from './Button.type';

const Button = ({
  label,
  className,
  leadingIcon,
  trailingIcon,
  ...otherProps
}: ButtonProps) => {
  const mergedClassName = cx('button-container', className);

  const renderIcon = (
    icon: ButtonProps['leadingIcon'] | ButtonProps['trailingIcon'] | undefined
  ) => {
    if (!icon) return null;

    if (React.isValidElement(icon)) {
      return icon;
    }

    const IconComponent = icon;
    return <IconComponent />;
  };

  return (
    <button type="button" className={mergedClassName} {...otherProps}>
      {renderIcon(leadingIcon)}
      {label}
      {renderIcon(trailingIcon)}
    </button>
  );
};
export default Button;
